/* eslint-disable @typescript-eslint/no-explicit-any */
import { EwaThunk } from "../types";
import * as requests from "../../requests/favouriteTemplates/requestCreators";
import * as actions from "./actions";
import * as selectors from "./selectors";
import { TemplateId } from "../../globalTypes";

export const fetchFavouriteTemplates =
  (): EwaThunk => async (dispatch, getState) => {
    const state = getState();

    const isFetching = selectors.getIsFetching(state);
    if (isFetching) return;

    dispatch(actions.fetchFavouriteTemplatesRequest());

    try {
      const response = await requests.fetchFavouriteTemplates();

      dispatch(actions.fetchFavouriteTemplatesSuccess(response.data));
    } catch (e) {
      if (!(e as any).response) {
        // error handling ...
        return;
      }
      dispatch(actions.fetchFavouriteTemplatesError((e as any).response)); // TODO: nějak to rozparsovat
    }
  };

export const toggleTemplateFavouriteStatus =
  (id: TemplateId, isFavourite: boolean): EwaThunk =>
  async (dispatch, getState) => {
    dispatch(actions.toggleFavouriteTemplateLocal(id));
    dispatch(actions.toggleFavouriteTemplateRequest(id));

    const appropriateRequestFunction = isFavourite
      ? requests.removeFavouriteTemplate
      : requests.addFavouriteTemplate;

    try {
      await appropriateRequestFunction(id);
    } catch (e) {
      if (!(e as any).response) {
        // error handling ...
        return;
      }
      dispatch(actions.toggleFavouriteTemplateError((e as any).response)); // TODO: nějak to rozparsovat
    } finally {
      dispatch(actions.toggleFavouriteTemplateSuccess());
      dispatch(fetchFavouriteTemplates());
    }
  };

export const changeOrder =
  (id: TemplateId, order: number): EwaThunk =>
  async (dispatch, getState) => {
    try {
      requests.patchFavouriteTemplate(id, { order }).then(() => {
        dispatch(actions.orderFavouriteTemplateSuccess());
        dispatch(fetchFavouriteTemplates());
      });
    } catch (e) {
      if (!(e as any).response) {
        // error handling ...
      }
    }
  };
